import { applyMiddleware, createStore } from 'redux';
import reducer from './reducer';
import { createLogger } from 'redux-logger';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { createBrowserHistory, createHashHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';
import { promiseMiddleware } from './middleware';
import createSagaMiddleware from 'redux-saga';
import chatSaga from './sagas/chatSaga';
import videoSaga from './sagas/videoSaga';
import socketSaga from './sagas/socketSaga';
import NewSocket from './socket';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { CONNECT_PRICE_CHANGE, EVENT_UPDATE, UPLOAD_PROGRESS } from './constants/actionTypes';

let historyInstance = createBrowserHistory();

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['common']
};

if (window.cordova) {
    historyInstance = createHashHistory();
}

export const history = historyInstance;
const persistedReducer = persistReducer(persistConfig, reducer(history));

const sagaMiddleware = createSagaMiddleware();

const getMiddleware = () => {
    if (process.env.NODE_ENV === 'production') {
        return applyMiddleware(routerMiddleware(history), promiseMiddleware, sagaMiddleware);
    } else {
        return applyMiddleware(
            routerMiddleware(history),
            promiseMiddleware,
            sagaMiddleware,
            createLogger()
            // {
            // predicate: (getState, action) => ![ UPLOAD_PROGRESS , EVENT_UPDATE , CONNECT_PRICE_CHANGE ].some( a => a === action.type ),
            //     collapsed: (getState, action, logEntry) => !logEntry.error,
            //     actionTransformer : (action) => {console.info(JSON.stringify(action)); return action;}
            // }
        );
    }
};

const createdStore = createStore(persistedReducer, composeWithDevTools(getMiddleware()));
let persistor = persistStore(createdStore);
const socket = NewSocket(createdStore.dispatch);
socket.connect();

createdStore.chatSaga = sagaMiddleware.run(chatSaga, { socket, createdStore });
createdStore.videoSaga = sagaMiddleware.run(videoSaga, { socket });
createdStore.socketSaga = sagaMiddleware.run(socketSaga, { socket, createdStore });
export const store = createdStore;
export const persist = persistor;
